
export function formatCurrencyNis(amount: number): string {
    return amount.toLocaleString('he-IL', { style: 'currency', currency: 'ILS' });
}